module.exports = __webpack_public_path__ + "static/smilingfarmer-08f5b78d6c4a1ec7917b31c40273173b.jpeg";